const _require = require('../lib/benhur/totals'),
  benhurEstimateTotals = _require.benhurEstimateTotals;
const _require2 = require('../lib/evaluateSource'),
  evaluateSource = _require2.evaluateSource;

/**
  * @function evaluate - evaluate benhurEstimateTotalsBehavior
  */

const evaluate = async (source, content, parentContentPath, transientContext, nativeFunctions) => {
  const values = await evaluateSource(source.values, content, parentContentPath, transientContext, nativeFunctions);
  return benhurEstimateTotals(values);
};
module.exports = {
  evaluate
};